/** Where a timeline row's related record opens. Closed list: unknown types render as plain text. */
const RECORD_LINKS: Record<string, { path: (id: string) => string; capability: string }> = {
  crm2_leads: { path: (id) => `/leads/${id}`, capability: "crm.leads" },
  crm2_opportunities: { path: (id) => `/opportunities/${id}`, capability: "crm.opportunities" },
  crm2_quotes: { path: (id) => `/quotes/${id}`, capability: "crm.quotes" },
  crm2_orders: { path: (id) => `/orders/${id}`, capability: "crm.orders" },
  crm2_invoices: { path: (id) => `/invoices/${id}`, capability: "crm.invoices" },
  crm2_support_tickets: { path: (id) => `/support/${id}`, capability: "crm.support" },
  crm2_sales_cycle_runs: { path: (id) => `/sales-cycle/${id}`, capability: "crm.sales_cycle" },
};

export function recordLink(
  type: string | null | undefined,
  id: string | null | undefined,
): { path: string; capability: string } | null {
  if (!type || !id) return null;
  const entry = RECORD_LINKS[type];
  return entry ? { path: entry.path(id), capability: entry.capability } : null;
}
